<template>
    <div class="card">
        <div class="card-header">
            <font-awesome-icon :icon="['fas', 'hotel']" class="mr-1"/>
            {{ title }}
            <div class="card-header-actions">
                <router-link :to="{ name: 'ClientsAdd' }" v-if="showAdd" class="mr-1">
                    <font-awesome-icon :icon="['fas', 'plus']" class="nav-icon"/>
                    {{ $t('global.buttons.add') }}
                </router-link>

                <!-- Botón para volver a la página principal de edición del cliente -->
                <router-link :to="{ name: 'ClientsEdit', params: { id: clientId } }" v-if="showEdit" class="mr-1">
                    <font-awesome-icon :icon="['fas', 'edit']" class="m-0"/>
                    {{ $t('global.buttons.edit') }}
                </router-link>

                <!-- Botón para ir a la sección de administrar cliente -->
                <router-link :to="{ name: 'MarkupLayout', params: { client_id: clientId, region_id: 1 } }" v-if="showManageClient">
                    <font-awesome-icon :icon="['fas', 'dot-circle']" class="m-0"/>
                    Administrar cliente
                </router-link>
            </div>
        </div>
        <div class="card-body">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            title: '',
            adminclient: '',
            clientId: null
        }
    },
    created: function () {
        this.adminclient = this.$i18n.t('clients.manage_client');
        this.updateClientId(this.$route);
        this.showTitle();

        this.$root.$on('updateTitle', () => {
            this.showTitle()
        })
    },
    watch: {
        '$route' (to, from) {
            this.updateClientId(to);
            this.showTitle();
        }
    },
    computed: {
        showAdd () {
            return this.$route.name === 'ClientsList' && this.$can('create', 'clients')
        },
        showEdit() {
            const isManageRoute = this.$route.path.includes('manage_client');
            return isManageRoute && this.clientId && this.$can('update', 'clients');
        },
        showManageClient() {
            const isManageRoute = this.$route.path.includes('manage_client');
            // Show only if we have a clientId, are NOT in a manage route, and NOT in the list view.
            return !isManageRoute && this.clientId && this.$route.name !== 'ClientsList' && this.$can('update', 'clients');
        }
    },
    methods: {
        updateClientId(route) {
            this.clientId = route.params.id || route.params.client_id;
        },
        showTitle: function () {
            const baseTitle = this.$i18n.t('clients.title');
            const clientName = localStorage.getItem('clientnamemanage');

            if (clientName === baseTitle) {
                this.title = baseTitle;
            } else {
                this.title = baseTitle + ' : ' + clientName;
            }
        }
    }
}
</script>

<style lang="stylus">
</style>
